/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProvisioningDeviceResponse,
    ProvisioningDeviceResponseFromJSON,
    ProvisioningDeviceResponseFromJSONTyped,
    ProvisioningDeviceResponseToJSON,
} from './ProvisioningDeviceResponse';

/**
 * 
 * @export
 * @interface ProvisioningDevicesResponse
 */
export interface ProvisioningDevicesResponse {
    /**
     * 
     * @type {Array<ProvisioningDeviceResponse>}
     * @memberof ProvisioningDevicesResponse
     */
    elements: Array<ProvisioningDeviceResponse>;
    /**
     * 
     * @type {number}
     * @memberof ProvisioningDevicesResponse
     */
    totalElementCount: number | null;
}

export function ProvisioningDevicesResponseFromJSON(json: any): ProvisioningDevicesResponse {
    return ProvisioningDevicesResponseFromJSONTyped(json, false);
}

export function ProvisioningDevicesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProvisioningDevicesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(ProvisioningDeviceResponseFromJSON)),
        'totalElementCount': json['totalElementCount'],
    };
}

export function ProvisioningDevicesResponseToJSON(value?: ProvisioningDevicesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(ProvisioningDeviceResponseToJSON)),
        'totalElementCount': value.totalElementCount,
    };
}

